import { render } from "./InitializeMenu.vue?vue&type=template&id=935ca620"
import script from "./InitializeMenu.vue?vue&type=script&lang=js"
export * from "./InitializeMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__